import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-738d948a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "services_menu" };
const _hoisted_2 = { class: "container service_menu__navigation--tabs" };
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "container" };
const _hoisted_5 = { class: "service_menu__content" };
const _hoisted_6 = ["id"];
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'services_menu',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const activeImageSplit = ref();
        const servicesNavigation = ref(null);
        const shadowOpacity = ref(1);
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 1023);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 1023;
        });
        function bigTextBreakerData() {
            return {
                title: props.d.title,
                background_colour: '#fff'
            };
        }
        onMounted(() => {
            updateImageSplitActiveState();
            window.addEventListener('scroll', updateImageSplitActiveState);
        });
        const isActive = (index) => {
            // Logic to determine if the title should be active based on the content
            return index == activeImageSplit.value;
        };
        function updateImageSplitActiveState() {
            const contentDivs = document.querySelectorAll('.service_menu__content--item');
            let currentContentId = 1; // Default to first content
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const shadowElement = document.querySelector('.service_menu__navigation--shadow');
            if (shadowElement) {
                const shadowRect = shadowElement.getBoundingClientRect();
                if (shadowRect.top >= 0 && shadowRect.top <= 85) {
                    shadowOpacity.value = 0;
                }
                else {
                    shadowOpacity.value = 1;
                }
            }
            // Calculate the threshold position based on window height
            const thresholdPosition = windowHeight * 0.5;
            // Loop through content divs to find the one at the top of the viewport
            contentDivs.forEach((div, index) => {
                const rect = div.getBoundingClientRect();
                // Check if the top of the content div is at least 50% visible in the viewport
                if (rect.top <= thresholdPosition && rect.bottom >= 0) {
                    currentContentId = index + 1; // Index starts from 0, add 1 to match IDs
                }
            });
            // Update rightSideContent with the ID of the content at the top
            activeImageSplit.value = currentContentId;
        }
        function imageSplitContent(index) {
            const data = props.d.services_menu_items[index];
            return {
                line_one: data.line_one ?? '',
                line_two: data.line_two ?? '',
                font_style: data.absolute_brand_font ?? 'normal',
                line_three: data.line_three ?? '',
                image: data.image ?? '',
                image_alt: data.image_alt ?? '',
                leadin: data.leadin ?? null,
                cta_title: data.cta_text ?? '',
                cta_link: data.cta_link ?? '',
                background_colour: '#FFF',
                padding_top: 'top_spacing-50',
                padding_bottom: 'bottom_spacing-50',
            };
        }
        return (_ctx, _cache) => {
            const _component_big_text_breaker = _resolveComponent("big-text-breaker");
            const _component_image_split = _resolveComponent("image-split");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_big_text_breaker, {
                    d: bigTextBreakerData()
                }, null, 8, ["d"]),
                (!isMobile.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "service_menu__navigation",
                        ref_key: "servicesNavigation",
                        ref: servicesNavigation
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.services_menu_items, (item, index) => {
                                return (_openBlock(), _createElementBlock("a", {
                                    href: '#image-split-' + (index + 1).toString(),
                                    class: _normalizeClass(["service_menu__navigation--tab no-style", { 'service_menu__navigation--tab__active': isActive(index + 1) }])
                                }, _toDisplayString(item.tab_title), 11, _hoisted_3));
                            }), 256))
                        ])
                    ], 512))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: "service_menu__navigation--shadow",
                    style: _normalizeStyle({ opacity: shadowOpacity.value })
                }, null, 4),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.services_menu_items, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "module service_menu__content--item top_spacing-100 bottom_spacing-75",
                                id: 'image-split-' + (index + 1).toString()
                            }, [
                                _createVNode(_component_image_split, {
                                    d: imageSplitContent(index)
                                }, null, 8, ["d"])
                            ], 8, _hoisted_6));
                        }), 256))
                    ])
                ])
            ]));
        };
    }
});
